<template>
    <div class="wrapper">
        <p class="title">{{ $t("userAMLQuestionnaire.secondStep.labelOne") }}</p>
        <div class="inputs-wrapper">
            <p class="label">{{ $t("userAMLQuestionnaire.secondStep.labelTwo") }}</p>
            <multiselect v-model="selectedProfession"
                :options="professions"
                :allow-empty="false"
                :show-labels="false"
                track-by="display"
                label="display"
                :placeholder="$t('userAMLQuestionnaire.secondStep.placeholder')"
                :class="['label__input', { 'label__input--active': selectedProfession }]"
                searchable
                @input="onProfessionChanged"
            >
                <template slot="singleLabel"
                    slot-scope="props"
                >
                    {{ $t(props.option.display) }}
                </template>
                <template slot="option"
                    slot-scope="props"
                >
                    {{ $t(props.option.display) }}
                </template>
                <span slot="noResult">{{ $t('userAMLQuestionnaire.noResults') }}</span>
            </multiselect>

            <div v-if="isOtherProfession">
                <p class="label">{{ $t("userAMLQuestionnaire.secondStep.labelThree") }}</p>
                <input id="other-profession"
                    v-model.trim="otherProfession"
                    :class="['label__input', { 'label__input--active': otherProfession }]"
                    autocomplete="off"
                    :placeholder="$t('userAMLQuestionnaire.secondStep.otherProfessionPlaceholder')"
                    @input="onTextChanged"
                >
            </div>
        </div>
    </div>
</template>

<script>
import {
    professions,
} from './questionnaire.const';

export default {
    name: 'question-2',
    data() {
        return {
            selectedProfession: null,
            otherProfession: '',
            professions,
        };
    },
    computed: {
        isOtherProfession() {
            return this.selectedProfession?.value === 'other';
        },
    },
    methods: {
        emitCompleted() {
            this.$emit('completed', {
                profession: this.selectedProfession?.value,
                professionOther: this.otherProfession,
            });
        },
        onProfessionChanged() {
            if (this.isOtherProfession) {
                this.$emit('in-progress');

                return;
            }

            this.otherProfession = '';
            this.emitCompleted();
        },
        onTextChanged() {
            if (!this.otherProfession) {
                this.$emit('in-progress');

                return;
            }

            this.emitCompleted();
        },
        resetStep() {
            this.selectedProfession = null;
            this.otherProfession = '';
        },
    },
};
</script>

<style lang="scss" scoped>
.wrapper {
    .title {
        font-size: 1.75rem;
        line-height: 23px;
    }

    .inputs-wrapper {
        max-width: 450px;

        .label {
            font-size: 1.4rem;
            line-height: 18px;
            margin-top: 30px;
            font-weight: bold;
        }
    }
}
</style>